<template>
  <div class="wrap-alert-conten-eos">
    <v-progress-linear :active="!loading" color="primary accent-4" indeterminate></v-progress-linear>
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex"></div>
      <div>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" x-small right @click="save()"><v-icon small>mdi-content-save</v-icon></v-btn>
          </template>
          <span>{{ $t('common.save') }}</span>
        </v-tooltip>
      </div>
    </v-card>
    <tree-grid v-if="loading" ref="alertEos" dense :columns="columns" :tree="tree" :empty-text="emptyText" :class="'dense'">
      <template v-slot:cell.dbEos="{ row }">
        <!--
          v-if에서 row.dbEos 값을 비교하면, 시스템이 등록된 후 최초에 EOS 필드에 값이 없을 때 DatePicker가 뜨지 않아 값을 입력할 수 없다.
          2021.02.24.Modified.by.KWShin.
        -->
        <v-menu v-if="row.type === 'SYSTEM'" v-model="row._dbEosShow" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="row.dbEos" prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" hide-details dense class="eos-date"></v-text-field>
          </template>
          <v-date-picker v-model="row.dbEos" :day-format="date => new Date(date).getDate()" no-title @input="closePicker(row, 'dbEos')"></v-date-picker>
        </v-menu>
      </template>
      <template v-slot:cell.osEos="{ row }">
        <!--
          System이냐 Instance이냐에 따라 EOS 필드가 서로 상이하므로 row.osEos나 row.sapEos의 값으로 v-if를 비교해서는 안되고,
          데이터의 유형으로 비교해주어야 한다.
          2021.02.24.Modified.by.KWShin.
        -->
        <v-menu v-if="row.type === 'ABAP_INSTANCE' || row.type === 'JAVA_INSTANCE'" v-model="row._osEosShow" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="row.osEos" prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" hide-details dense></v-text-field>
          </template>
          <v-date-picker v-model="row.osEos" :day-format="date => new Date(date).getDate()" no-title @input="closePicker(row, 'osEos')"></v-date-picker>
        </v-menu>
      </template>
      <template v-slot:cell.sapEos="{ row }">
        <v-menu v-if="row.type === 'ABAP_INSTANCE' || row.type === 'JAVA_INSTANCE'" v-model="row._sapEosShow" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="row.sapEos" prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" hide-details dense></v-text-field>
          </template>
          <v-date-picker v-model="row.sapEos" :day-format="date => new Date(date).getDate()" no-title @input="closePicker(row, 'sapEos')"></v-date-picker>
        </v-menu>
      </template>
    </tree-grid>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _cloneDeep from 'lodash/cloneDeep';
import _ from 'lodash';
import TreeGrid from '../../../components/grid/TreeGrid';
import { format } from 'date-fns';

export default {
  name: 'Eos',
  components: {
    TreeGrid,
  },
  data() {
    return {
      loading: false,
      isShow: false,
      tempTree: [],
      tree: [],
      emptyText: this.$t('$vuetify.noDataText'),
      columns: [
        { type: 'prop', prop: 'name', label: this.$t('alert.eos.name'), width: '30%' },
        { type: 'prop', prop: 'version', label: this.$t('alert.eos.version') },
        { type: 'prop', prop: 'system', label: this.$t('alert.eos.system') },
        { type: 'prop', prop: 'dbEos', label: this.$t('alert.eos.dbms') },
        { type: 'prop', prop: 'osEos', label: this.$t('alert.eos.os') },
        { type: 'prop', prop: 'sapEos', label: this.$t('alert.eos.sap') },
      ],
      newTreeObj: [],
    };
  },
  computed: {
    ...mapState('preference/alert', ['eosData', 'updateEosStatus']),
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  watch: {
    eosData(val) {
      if (val) {
        this.tempTree = _cloneDeep(val);
        this.makeFlat(val);
      }
    },
    updateEosStatus(val) {
      if (val === 'success') this.isSucess();
    },
    newTreeObj(val) {
      this.makeTree(_.uniqWith(val, _.isEqual));
    },
    tree: {
      handler() {
        this.$nextTick(() => {
          this.loading = true;
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    fetchAlertEos() {
      this.$store.dispatch('preference/alert/alertEos');
    },
    makeFlat(data) {
      [...data].map(item => {
        this.newTreeObj.push({
          id: item.id,
          name: item.name,
          parentId: item.parentId,
          version: item.version,
          system: item.system,
          type: item.type,
          dbEos: this.newDateFormat(item.dbEos),
          osEos: this.newDateFormat(item.osEos),
          sapEos: this.newDateFormat(item.sapEos),
          _isExpanded: false,
          _dbEosShow: false,
          _osEosShow: false,
          _sapEosShow: false,
        });
        if (item.children.length > 0) {
          this.makeFlat(item.children);
        }
      });
    },
    makeTree(flat) {
      const root = [];
      flat.forEach(node => {
        if (!node.parentId) return root.push(node);
        const parentIndex = flat.findIndex(el => el.id === node.parentId);
        if (!flat[parentIndex].children) {
          return (flat[parentIndex].children = [node]);
        }
        flat[parentIndex].children.push(node);
      });
      this.tree = root;
    },
    fetchUpdateEos() {
      const differences = _.differenceWith(this.tempTree, this.eosData, _.isEqual);
      if (differences.length !== 0) {
        this.$store.dispatch('preference/alert/updateEos', differences);
      }
    },
    isSucess() {
      this.$dialog.info(this.$t('common.successful'));
    },
    async save() {
      if (await this.$dialog.confirm(this.$t('common.save.all.q'))) {
        this.fetchUpdateEos();
      }
    },
    newDateFormat(date) {
      if (!date) return null;
      return !date ? '' : this.getTimeFormat(date);
    },
    setTreeValue(path, key, value) {
      this.$refs.alertEos.$refs.treeGridTable.setValue(path, key, value);
      _.set(this.tree, `${path}.${key}`, value);
    },
    getTimeFormat(date) {
      return format(new Date(date), 'yyyy-MM-dd');
    },
    getUnixTime(date) {
      return Math.floor(new Date(date).getTime());
    },
    getValue(obj, path, key) {
      return _.get(obj, [path, key].join('.'));
    },
    setValue(obj, path, key, value) {
      _.set(obj, [path, key].join('.'), value);
    },
    getStatus(obj, path, key, value) {
      let changeValue = value !== 'NOTEXISTED' ? 'UPDATED' : 'INSERTED';
      return changeValue;
    },
    changeStatus(obj, path, key) {
      let tempValue = this.getValue(obj, path, key);
      this.setValue(obj, path, key, this.getStatus(tempValue));
    },
    closePicker(row, text) {
      this.setTreeValue(row._path, `_${text}Show`, false);
      let originDate = this.getValue(this.tempTree, row._path, text);
      let newDate = this.getUnixTime(new Date(row[text]));
      if (originDate !== newDate) {
        this.setValue(this.tempTree, row._path, text, newDate);
        this.changeStatus(this.tempTree, row._path, 'status');
      }
    },
  },
  created() {
    this.fetchAlertEos();
  },
};
</script>

<style lang="scss" scoped>
.top-row {
  margin: 0 0 0 0;
}

.v-data-table__wrapper {
  overflow-x: hidden !important;
}

.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.isHide {
  display: none;
}

.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  padding: 0 !important;
}

.v-text-field__slot {
  > input {
    font-size: 10.5px;
  }
}
</style>
